import requestv2 from "~/utils/http-v2";

const formSalaryApi = {
	count : async (params) => {
		const url = 'v2/form/salary/count';
		return await requestv2.get(url, {params});
	},
	gets : async (params) => {
		const url = 'v2/form/salary';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/form/salary';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/form/salary/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/form/salary/${id}`;
		return await requestv2.delete(url);
	},
	status : async (params) => {
		const url = `v2/form/salary/status/${params.id}`;
		return await requestv2.post(url, params);
	},
};

export default formSalaryApi;